import { useState } from "react";
import fetchOstan from "./FetchOstan";
import InfoOstanView from "./infoOstanView";
import InstallButton from "./components/InstallButton";

export default function App() {
  const [province_name, setProvince_name] = useState("");
  const [province_id, setProvince_id] = useState("");
  const [error, setError] = useState("");
  const [postalCode, setPostalCode] = useState("");

  const getInfoOstan = async (postalCode) => {
    if (!navigator.onLine) {
      setError("به اینترنت متصل نیستی دلبندم!☢");
      return;
    }
    setError(null);
    setProvince_name(null)
    const { data, err } = await fetchOstan(postalCode);
    if (err) {
      setError(err)
      return
    } else {
      setError("");
      if (data) {
        setProvince_id(data.province_id);
        setProvince_name(data.province_name);
      }

    }
  }

  return (
    <div className="main-container">
      <InstallButton/>
      <input
        type="text"
        className="search"
        placeholder="کدپستی"
        value={postalCode}
        onChange={e => setPostalCode(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            getInfoOstan(postalCode);
          }
        }}
      />

      <InfoOstanView error={error} province_id={province_id} province_name={province_name} />
    </div>

  );
};
